export const components = {
  translatedComponent: {
    hi: 'Вiтаннячко',
  },
};
